export function addressLabel(item) {
        const parts = [];
        if (item.nazwa) parts.push(item.nazwa);
        if (item.miejscowosc && !String(item.nazwa || '').includes(item.miejscowosc)) parts.push(item.miejscowosc);
        if (item.kod_poczt) parts.push(item.kod_poczt);
        if (parts.length < 2 && item.gmina) parts.push(item.gmina);
        return parts.filter(Boolean).join(', ');
    }

export function addressMeta(item) {
        return [/^\d+$/.test(String(item.rodzaj || '')) ? null : item.rodzaj, item.powiat, item.wojewodztwo].filter(Boolean).join(' · ');
    }

